import { render, staticRenderFns } from "./IntroducingGiantAnt.vue?vue&type=template&id=35da0bd0&"
import script from "./IntroducingGiantAnt.vue?vue&type=script&lang=ts&"
export * from "./IntroducingGiantAnt.vue?vue&type=script&lang=ts&"
import style0 from "./IntroducingGiantAnt.vue?vue&type=style&index=0&id=35da0bd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports